@if (externalHref(); as href) {
  <a
    [href]="href"
    target="_blank"
    rel="noopener noreferrer"
    [ngClass]="classes()"
  >
    <ng-container *ngTemplateOutlet="contents"></ng-container>
  </a>
} @else {
  <button
    [type]="type()"
    [disabled]="isLoading() || disabled()"
    [ngClass]="classes()"
    (click)="onButtonClick()"
  >
    <ng-container *ngTemplateOutlet="contents"></ng-container>
  </button>
}

<ng-template #contents>
  <span
    class="btn-contents"
    [class.btn-hidden]="isLoading()"
  >
    @if (iconPosition() === 'left') {
      @if (customIcon()) {
        <ng-container *ngTemplateOutlet="customIcon()"></ng-container>
      } @else if (icon()) {
        <i-feather [name]="icon()"></i-feather>
      }
    }
    <ng-content></ng-content>
    @if (iconPosition() === 'right') {
      @if (customIcon()) {
        <ng-container *ngTemplateOutlet="customIcon()"></ng-container>
      } @else if (icon()) {
        <i-feather [name]="icon()"></i-feather>
      }
    }
  </span>

  @if (isLoading()) {
    <div class="loader-wrapper">
      <i-feather
        name="loader"
        class="animate-spin"
      ></i-feather>
    </div>
  }
</ng-template>
